//
//  useProgress.ts
//
//  isana.net,inc. Proprietary and Confidential
//

import { useState } from "react";

const useProgress = () => {
  const [open, setOpen] = useState<boolean>(false);

  const show = async (process: () => Promise<void>) => {
    setOpen(true);

    await process();

    setOpen(false);
  };

  return {
    open,
    show,
  };
};

export default useProgress;
